(function () {
  if (window.VaultLookbookProduct) { window.vaultInit.drain('LookbookProduct'); return; }
  /* Shared listeners live once per document; section work is released on removal. */
  if (!window.vaultInit.scope) {
    var scopes = new Set(), hubs = new Map();
    function dispose(scope) {
      if (!scope.alive) return;
      scope.alive = false;
      Array.from(scope.cleanups).reverse().forEach(function (fn) { fn(); });
      scope.cleanups.clear();
      scopes.delete(scope);
      delete scope.root.__vaultPhases;
    }
    function sectionScope(root, name) {
      for (var existing of scopes) if (existing.root === root && existing.name === name) return existing;
      var scope = { root: root, name: name, alive: true, cleanups: new Set() };
      scopes.add(scope);
      scope.cleanup = function (fn) { scope.cleanups.add(fn); };
      scope.on = function (site, target, type, fn, options) {
        if (!scope.alive) return;
        if ((target === document && type === 'DOMContentLoaded' && document.readyState !== 'loading') ||
            (target === window && type === 'load' && document.readyState === 'complete')) {
          scope.timeout(function () { fn.call(target, new Event(type)); }, 0);
          return;
        }
        var capture = options === true || !!(options && options.capture);
        if (target === document || target === window) {
          var key = name + ':' + site + ':' + (target === window ? 'w:' : 'd:') + type + ':' + capture + ':' + !!(options && options.passive);
          var hub = hubs.get(key);
          if (!hub) {
            hub = new Set(); hubs.set(key, hub);
            target.addEventListener(type, function (event) {
              var stopped = false, stop = event.stopImmediatePropagation;
              event.stopImmediatePropagation = function () { stopped = true; stop.call(event); };
              try {
                for (var item of Array.from(hub)) {
                  if (!item.scope.root.isConnected) { dispose(item.scope); continue; }
                  if (!item.scope.alive) continue;
                  if (item.once) { hub.delete(item); item.scope.cleanups.delete(item.cleanup); }
                  item.fn.call(target, event);
                  if (stopped) break;
                }
              } finally { event.stopImmediatePropagation = stop; }
            }, { capture: capture, passive: !!(options && options.passive) });
          }
          var item = { scope: scope, target: target, type: type, capture: capture, fn: fn, once: !!(options && options.once) };
          hub.add(item);
          item.cleanup = function () { hub.delete(item); };
          scope.cleanup(item.cleanup);
        } else {
          target.addEventListener(type, fn, options);
          scope.cleanup(function () { target.removeEventListener(type, fn, options); });
        }
      };
      scope.off = function (target, type, fn, options) {
        var capture = options === true || !!(options && options.capture);
        hubs.forEach(function (hub) {
          hub.forEach(function (item) {
            if (item.scope === scope && item.target === target && item.type === type && item.capture === capture && item.fn === fn) {
              hub.delete(item); scope.cleanups.delete(item.cleanup);
            }
          });
        });
        target.removeEventListener(type, fn, options);
      };
      var jobs = new Map();
      scope.cleanup(function () { jobs.forEach(function (cancel, id) { cancel(id); }); jobs.clear(); });
      function schedule(fn, ms, interval, frame) {
        if (!scope.alive) return 0;
        var cancel = frame ? cancelAnimationFrame : interval ? clearInterval : clearTimeout;
        var run = function (time) {
          if (!interval) jobs.delete(id);
          if (!scope.alive || !root.isConnected) { if (interval) dispose(scope); return; }
          fn(time);
        };
        var id = frame ? requestAnimationFrame(run) : interval ? setInterval(run, ms) : setTimeout(run, ms);
        jobs.set(id, cancel);
        return id;
      }
      scope.timeout = function (fn, ms) { return schedule(fn, ms, false, false); };
      scope.interval = function (fn, ms) { return schedule(fn, ms, true, false); };
      scope.frame = function (fn) { return schedule(fn, 0, false, true); };
      scope.clear = function (id) { var cancel = jobs.get(id); if (cancel) cancel(id); jobs.delete(id); };
      scope.observe = function (observer) { scope.cleanup(function () { observer.disconnect(); }); return observer; };
      return scope;
    }
    sectionScope.prune = function () { scopes.forEach(function (scope) { if (!scope.root.isConnected) dispose(scope); }); };
    sectionScope.unload = function (node) {
      scopes.forEach(function (scope) {
        if (scope.root !== document.documentElement && (scope.root === node || node.contains(scope.root) || scope.root.contains(node))) dispose(scope);
      });
    };
    window.vaultInit.scope = sectionScope;
  }

  window.VaultLookbookProduct = window.VaultLookbookProduct || {
    init: function (phase, root) {
      var scope = window.vaultInit.scope(root, 'LookbookProduct');

  (function () {
    if (!root || root.__vip) return;
    root.__vip = true;
    scope.cleanup(function () { delete root.__vip; });
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-vip-config]').textContent); } catch (e) { return; }
    var html = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var CACHE = 'vault_vip_v8:' + cfg.themeId + ':';

    function ready(fn) { if (document.readyState === 'loading') scope.on('lookbook.0', document, 'DOMContentLoaded', fn, { once: true }); else fn(); }
    var productRoot = null, lookbookHost = null;
    function wornBox() {
      if (!productRoot) {
        var page = root.closest('main') || document;
        var products = Array.from(page.querySelectorAll('product-info[data-product-id="' + cfg.productId + '"]'));
        productRoot = products.find(function (el) {
          var box = el.querySelector('#vault-worn-by');
          return box && (!box.__vipOwner || box.__vipOwner === root);
        }) || products[0];
      }
      var box = productRoot ? productRoot.querySelector('#vault-worn-by') : (root.closest('main') || document).querySelector('#vault-worn-by');
      if (box && !box.__vipOwner) { box.__vipOwner = root; scope.cleanup(function () { delete box.__vipOwner; }); }
      return box;
    }
    function note(text) {
      if (!cfg.design) return;
      var box = wornBox();
      if (!box) return;
      var n = document.createElement('p');
      n.className = 'vip-note';
      n.textContent = 'Reminder (only you see this): ' + text;
      box.appendChild(n);
    }

    /* ---------- Read Looks from each idol page ---------- */
    /* The cache holds every Look on the idol page (with the products in it); each product page picks its own. */
    function readIdol(c) {
      var key = CACHE + c.url;
      function mine(d) {
        var own = d.looks.filter(function (lk) { return lk.ids.indexOf(String(cfg.productId)) > -1 || lk.handles.indexOf(cfg.productHandle) > -1; });
        return {
          /* A fandom page that only pulls its members' Looks doesn't count on its own (the member pages already do) */
          hasLookbook: d.hasLookbook && (!d.pull || own.length > 0),
          pronoun: d.pronoun,
          nameStyle: d.nameStyle,
          looks: own
        };
      }
      try {
        var hit = JSON.parse(localStorage.getItem(key) || 'null');
        if (hit && Date.now() >= hit.t && Date.now() - hit.t < 6 * 60 * 60 * 1000 && Array.isArray(hit.looks)) return Promise.resolve(mine(hit));
      } catch (e) {}
      var sectionId = '';
      try { sectionId = localStorage.getItem(key + ':section') || ''; } catch (e) {}
      function loadDocument(id) {
        var url = new URL(c.url, location.href);
        if (id) url.searchParams.set('section_id', id);
        return fetch(url.href, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (text) {
          if (!text) return id ? loadDocument('') : null;
          var doc = new DOMParser().parseFromString(text, 'text/html');
          /* A changed template invalidates the remembered section; discover it once again. */
          if (id && !doc.querySelector('[data-vil-root]')) return loadDocument('');
          return doc;
        });
      }
      /* Dynamic section IDs are only known after the idol page has rendered at least once. */
      return loadDocument(sectionId).then(function (doc) {
        var d = { hasLookbook: false, pronoun: 'HIM', looks: [] };
        if (!doc) return d;
        var lb = doc.querySelector('[data-vil-root]');
        if (lb) {
          var owner = lb.getAttribute('data-vil-owner');
          try { if (owner) localStorage.setItem(key + ':section', owner); } catch (e) {}
          d.hasLookbook = true;
          d.pronoun = lb.getAttribute('data-vil-pronoun') || 'HIM';
          d.pull = lb.hasAttribute('data-vil-pull');
          /* Idol name above the photo uses the same look as that page's VIEW HIS LOOKS button */
          var css = Array.prototype.map.call(doc.querySelectorAll('style'), function (st) { return st.textContent; }).filter(function (t) { return t.indexOf('--vil-cta-size:') > -1; })[0] || '';
          var pick = function (re, dflt) { var m = css.match(re); return m ? m[1].trim() : dflt; };
          var archivo = /\.vil__cta\s*\{[^}]*Archivo/.test(css);
          d.nameStyle = {
            d: pick(/--vil-cta-size:\s*([\d.]+px)/, '14px'),
            m: pick(/--vil-cta-size-m:\s*([\d.]+px)/, '10px'),
            c: pick(/--vil-cta-color:\s*([^;]+);/, '#000'),
            f: archivo ? "'Archivo Narrow', Arial, sans-serif" : "'Bebas Neue', Arial, sans-serif",
            ls: archivo ? '.12em' : '.08em'
          };
          lb.querySelectorAll('.vil__track [data-vil-look]').forEach(function (look, pos) {
            var media = look.querySelector('[data-vil-media]');
            if (!media) return;
            var ids = [], handles = [];
            media.querySelectorAll('[data-vil-spot]').forEach(function (s) {
              ids.push(s.getAttribute('data-product-id') || '');
              handles.push(s.getAttribute('data-product-handle') || '');
            });
            if (!ids.length) return;
            media.querySelectorAll('[data-shopify-editor-block]').forEach(function (el) { el.removeAttribute('data-shopify-editor-block'); });
            d.looks.push({ media: media.outerHTML, caption: look.getAttribute('data-caption') || '', ids: ids, handles: handles, n: pos + 1,
              lookId: look.getAttribute('data-look-id') || '', added: look.getAttribute('data-added') || '', pin: look.getAttribute('data-pin') === 'true', priority: parseInt(look.getAttribute('data-priority'), 10) || 0, custom: look.classList.contains('vil-look--custom'), style: look.getAttribute('style') || '' });
          });
        }
        try { d.t = Date.now(); localStorage.setItem(key, JSON.stringify(d)); } catch (e) {}
        return mine(d);
      }).catch(function () { return { hasLookbook: false, looks: [] }; });
    }

    function whenNearWornBy(box, load) {
      if (!box) return;
      /* The empty placeholder and its wrapper are display:none: observe the nearest laid-out neighbour. */
      var anchor = box;
      for (var i = 0; anchor && i < 8; i++) {
        var r = anchor.getBoundingClientRect();
        if (r.width && r.height) break;
        var neighbour = anchor.previousElementSibling || anchor.nextElementSibling;
        var nr = neighbour && neighbour.getBoundingClientRect();
        if (nr && nr.width && nr.height) { anchor = neighbour; break; }
        anchor = anchor.parentElement;
      }
      if (!anchor) return;
      var started = false;
      function start() { if (!started) { started = true; load(); } }
      if (window.IntersectionObserver) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); start(); }
        }, { rootMargin: window.innerHeight + 'px 0px' });
        scope.observe(observer).observe(anchor);
      } else {
        var check = function () {
          var r = anchor.getBoundingClientRect();
          if (r.bottom >= -window.innerHeight && r.top <= window.innerHeight * 2) {
            scope.off(window, 'scroll', check); scope.off(window, 'resize', check); start();
          }
        };
        scope.on('lookbook.1', window, 'scroll', check, { passive: true });
        scope.on('lookbook.2', window, 'resize', check, { passive: true });
        check();
      }
    }

    ready(function () {
      var box = wornBox();
      if (!cfg.cands.length) return;
      cfg.cands.forEach(function (c) { c.name = String(c.name || '').replace(/#/g, '').trim(); }); // "#GAWON" → "GAWON"
      /* Group pages (ARMY, A'TIN…) only repeat their members' Looks and are the heaviest to load:
         skip them when a member page is already in the list. */
      if (cfg.cands.some(function (c) { return c.group; })) cfg.cands = cfg.cands.filter(function (c) { return c.group; });
      function loadLooks() {
      Promise.all(cfg.cands.map(readIdol)).then(function (res) {
        if (!scope.alive || !root.isConnected) return;
        var idols = [];
        var missing = [];
        res.forEach(function (d, i) {
          if (!d.hasLookbook) return;
          if (d.looks.length) idols.push({ artistId: cfg.cands[i].artistId || '', groupId: cfg.cands[i].groupId || '', group: cfg.cands[i].group || '', name: cfg.cands[i].name, url: cfg.cands[i].url, pronoun: d.pronoun, nameStyle: d.nameStyle, looks: d.looks });
          else missing.push(cfg.cands[i].name);
        });
        if (missing.length) note('this product is tagged ' + missing.join(', ') + ', but no Look on that idol page has a hotspot on it, so it isn\'t shown here.');
        if (!idols.length) return; // 0 idols → keep the Aspiration video, no box
        var looks = [];
        /* Take turns: the 1st Look of each idol first, then the 2nd of each, and so on */
        var most = Math.max.apply(null, idols.map(function (idol) { return idol.looks.length; }));
        for (var k = 0; k < most; k++) idols.forEach(function (idol) {
          var lk = idol.looks[k];
          if (lk) looks.push({ lookId: lk.lookId, added: lk.added, pin: lk.pin, priority: lk.priority, artistId: idol.artistId, groupId: idol.groupId, media: lk.media, caption: lk.caption, idol: idol.name + (idol.group ? ' (' + idol.group + ')' : ''), nameStyle: idol.nameStyle, custom: lk.custom, style: lk.style, href: idol.url + (lk.lookId ? '#vlook=' + encodeURIComponent(lk.lookId) : '#look-' + (lk.n || 1)), /* by Look ID: the idol page may be personalized into a different order */ seeAll: String(cfg.seeAll || '').replace(/\{name\}/g, idol.name) });
        });
        looks = pzOrder(looks); // personalized order, decided once before the lookbook is built
        /* One source of truth: the names follow the ranked Looks (artist of the 1st Look first, and so on) */
        var rankOf = {};
        looks.forEach(function (lk, i) { if (!(lk.idol in rankOf)) rankOf[lk.idol] = i; });
        idols.sort(function (a, b) {
          var ka = a.name + (a.group ? ' (' + a.group + ')' : ''), kb = b.name + (b.group ? ' (' + b.group + ')' : '');
          return (ka in rankOf ? rankOf[ka] : 1e9) - (kb in rankOf ? rankOf[kb] : 1e9);
        });
        var lb = buildLookbook(looks);
        if (box) buildBox(box, idols, looks.length, lb);
        styleGate(box);
        if (window.VaultPZ && window.VaultPZ.rendered) {
          window.VaultPZ.rendered('domOrder', Array.prototype.map.call(document.querySelectorAll('#vault-worn-by .vip-slide, .vip-root .vip-slide'), function (sl) { return { lookId: sl.__pzLook, label: sl.__pzLabel || '' }; })
            .filter(function (x, i, arr) { return x.lookId && arr.findIndex(function (y) { return y.lookId === x.lookId; }) === i; }));
          window.VaultPZ.rendered('buttonOrder', idols.map(function (i) { return { label: i.name }; }));
        }
      });
      }
      whenNearWornBy(box, loadLooks);
    });

    /* ---------- Personalization (assets/vault-personalize.js) ---------- */
    var pzOpened = false, pzMeta = null;
    function pzProduct() {
      if (!pzMeta && window.VaultPZ) pzMeta = window.VaultPZ.productFromData(cfg.productId, cfg.pz && cfg.pz.brand, cfg.pz && cfg.pz.cat, cfg.pz && cfg.pz.anc);
      return pzMeta;
    }
    /* Fail open: if personalization breaks for any reason, WORN BY keeps the editorial order and still builds */
    function pzOrder(looks) {
      try {
        var out = pzOrderRaw(looks);
        if (!Array.isArray(out) || out.length !== looks.length || out.some(function (x) { return !x; })) return looks;
        return out;
      } catch (err) {
        if (/vault_rank_debug=1/.test(location.search) && window.console) console.warn('[VaultRank] WORN BY ranking failed, editorial order kept:', err);
        return looks;
      }
    }
    function pzOrderRaw(looks) {
      var P = window.VaultPZ;
      if (!P || looks.length < 2 || (window.Shopify && window.Shopify.designMode)) return looks;
      var cands = looks.map(function (lk, i) {
        var doc = new DOMParser().parseFromString(lk.media, 'text/html'), products = [], has = {};
        doc.querySelectorAll('[data-vil-spot]').forEach(function (sp) { var p = P.productFromSpot(sp); if (p && !has[p.id]) { has[p.id] = 1; products.push(p); } });
        return { id: lk.lookId || ('look:?:' + i), label: lk.idol, artist: lk.artistId, groups: lk.groupId ? [lk.groupId] : [], products: products, pos: i,
          pinned: !!lk.pin, priority: Math.max(0, Math.min(10, lk.priority || 0)), added: lk.added || '', hidden: false, curatedPin: -1, lk: lk };
      });
      var byId = {};
      cands.forEach(function (c) { if (!byId[c.id]) byId[c.id] = c.lk; });
      if (Object.keys(byId).length !== cands.length) return looks;
      return P.rank({ page: 'product', looks: cands }).map(function (id) { return byId[id]; });
    }
    function pzSlideCtx(slide) { return { artist: slide && slide.__pzArtist, groups: slide && slide.__pzGroups || [] }; }
    function pzMoved(slide) {
      if (!window.VaultPZ || !slide) return;
      window.VaultPZ.track('look_swipe', pzSlideCtx(slide), 'ls:' + slide.__pzLook);
    }
    if (window.VaultPZ || document.readyState === 'loading') {
      var pzStartView = function () { if (window.VaultPZ) window.VaultPZ.pageView('product_page_view', { product: pzProduct() }, 'product:' + cfg.productId); };
      if (window.VaultPZ) pzStartView(); else scope.on('lookbook.3', document, 'DOMContentLoaded', pzStartView, { once: true });
    }

    /* ---------- Style gate ----------
       The idols wore THIS product. A look picked in the style tiles (another product's variant) is not what
       they wore: the WORN BY box and the lookbook fade out like the price (blur out 180ms) and come back
       (zoom-blur in 450ms) for the product's own styles. Nothing on screen ever moves: the space is only
       given back (or taken) while it is off screen – above the screen the scroll is corrected. */
    function styleGate(box) {
      var host = lookbookHost;
      var grow = box && box.querySelector('.vip-grow');
      var slot = host && host.parentNode !== root ? host.parentNode : null;
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var parts = [];
      if (grow) parts.push({ fade: grow.querySelector('.vip-worn'), area: grow, collapse: function (off) { grow.style.display = off ? 'none' : ''; } });
      if (host) parts.push({ fade: host, area: slot || root, collapse: function (off) {
        host.style.display = off ? 'none' : '';
        if (slot) Array.prototype.forEach.call(slot.children, function (ch) { if (ch !== host) ch.style.display = off ? '' : 'none'; });
      } });
      if (!parts.length) return;
      var shown = true;
      function onScreen(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight && r.height > 0; }
      function layout(p, off) {
        // a hidden area measures 0×0 at the top (it would count as "above"): measure where it really is
        var area = p.area, seen = area.getClientRects().length > 0, r0 = area.getBoundingClientRect();
        p.collapse(off);
        var r1 = area.getBoundingClientRect();
        var above = seen ? r0.bottom <= 0 : (area.getClientRects().length > 0 && r1.bottom <= 0);
        if (above) window.scrollBy(0, r1.height - (seen ? r0.height : 0));
        p.collapsed = off;
      }
      function fade(el, on) {
        if (!el || !el.animate || calm) { if (el) el.style.opacity = on ? '' : '0'; return; }
        if (el.vGate) el.vGate.cancel();
        el.vGate = el.animate(on
          ? [{ opacity: 0, filter: 'blur(6px)', transform: 'scale(0.96)' }, { opacity: 1, filter: 'blur(0)', transform: 'scale(1)' }]
          : [{ opacity: 1, filter: 'blur(0)', transform: 'scale(1)' }, { opacity: 0, filter: 'blur(6px)', transform: 'scale(0.96)' }],
          on ? { duration: 450, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' } : { duration: 180, easing: 'ease-in', fill: 'forwards' });
        el.style.pointerEvents = on ? '' : 'none';
      }
      function apply(on) {
        if (on === shown) return;
        shown = on;
        parts.forEach(function (p) {
          if (on) {
            var wasOff = p.collapsed;
            if (wasOff) {
              // its space comes back now only if that can't be seen; on screen it waits until it scrolls away
              if (onScreen(p.area) && !p.waiting) { p.waiting = true; return; }
              layout(p, false);
            }
            p.waiting = false;
            fade(p.fade, true);
          } else {
            p.waiting = false;
            if (onScreen(p.area)) fade(p.fade, false); // stays in place, invisible, until it is off screen
            else { fade(p.fade, false); layout(p, true); }
          }
        });
      }
      // off screen again: give back / take the space
      function sweep() {
        parts.forEach(function (p) {
          if (onScreen(p.area)) return;
          if (!shown && !p.collapsed) layout(p, true);
          if (shown && p.waiting) { p.waiting = false; layout(p, false); fade(p.fade, true); }
        });
      }
      scope.on('lookbook.4', window, 'scroll', function () { if (sweep.t) return; sweep.t = scope.timeout(function () { sweep.t = 0; sweep(); }, 120); }, { passive: true });
      function isLook(v) { return !!(v && v.look); }
      scope.on('lookbook.5', document, 'variant:change', function (e) { apply(!isLook(e.detail && e.detail.variant)); });
      var picker = productRoot && productRoot.querySelector('vault-picker');
      if (picker && picker.variant) { try { apply(!isLook(picker.variant())); } catch (e) {} }
    }

    /* ---------- WORN BY box ---------- */
    function buildBox(box, idols, lookCount, lb) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vip-worn';
      if (idols.length > 1) {
        b.innerHTML = '<span class="vip-worn__lead"></span><span class="vip-worn__names"></span><span class="vip-worn__cta">VIEW THEIR LOOKS</span>';
        b.querySelector('.vip-worn__lead').textContent = 'WORN BY ' + idols.length + ' ARTISTS';
      } else {
        b.classList.add('vip-worn--one');
        b.innerHTML = '<span class="vip-worn__lead"></span><span class="vip-worn__cta"></span>';
        b.querySelector('.vip-worn__lead').textContent = 'WORN BY ' + idols[0].name;
        b.querySelector('.vip-worn__cta').textContent = lookCount > 1 ? 'VIEW ALL ' + lookCount + ' LOOKS' : 'SEE ' + (idols[0].pronoun || 'HIM') + ' WEARING IT';
      }
      var grow = document.createElement('div');
      grow.className = 'vip-grow';
      grow.innerHTML = '<div class="vip-grow__in"></div>';
      grow.firstChild.appendChild(b);
      box.insertBefore(grow, box.firstChild);
      scope.cleanup(function () { grow.remove(); });
      if (idols.length > 1) fitNames(b.querySelector('.vip-worn__names'), idols.map(function (i) { return i.name; }));
      /* Ready while the page is still opening: there at once (the buy box is centred, so a growing box made it
         slide up while the page settled – the buttons "jittered"). Ready later: it grows in. */
      if (document.readyState !== 'complete' || performance.now() < 2500) {
        grow.style.transition = 'none';
        grow.classList.add('is-in');
        b.classList.add('is-ready');
        void grow.offsetHeight;
        grow.style.transition = '';
      } else {
        void grow.offsetHeight;
        scope.frame(function () { grow.classList.add('is-in'); b.classList.add('is-ready'); });
        scope.timeout(function () { grow.classList.add('is-in'); b.classList.add('is-ready'); }, 60);
      }
      scope.on('lookbook.6', b, 'click', function (e) {
        if (e.isTrusted && window.VaultPZ && !pzOpened) { pzOpened = true; window.VaultPZ.track('lookbook_open', { page: 'product', product: pzProduct() }); }
        if (lb) lb.scrollIntoFocus();
      });
    }

    /* Up to 3 names then +N, on one line. Too long → show one name fewer; one name still too long → shrink it. */
    function fitNames(el, names) {
      var show = Math.min(cfg.maxNames, names.length);
      function paint() {
        var txt = names.slice(0, show).join(' · ');
        if (names.length > show) txt += ' · +' + (names.length - show);
        el.textContent = txt;
      }
      paint();
      while (el.scrollWidth > el.clientWidth + 1 && show > 1) { show--; paint(); }
      var size = parseFloat(getComputedStyle(el).fontSize);
      while (el.scrollWidth > el.clientWidth + 1 && size > 11) { size -= 1; el.style.fontSize = size + 'px'; }
    }

    /* ---------- Lookbook in the Aspiration slot ---------- */
    function findSlot() {
      var match = String(cfg.match || 'ASPIRATION').toUpperCase();
      var secs = document.querySelectorAll('.shopify-section');
      for (var i = 0; i < secs.length; i++) {
        if (secs[i].contains(root)) continue;
        if (!/ss_video_with_text/.test(secs[i].id)) continue;
        if ((secs[i].textContent || '').toUpperCase().indexOf(match) === -1) continue;
        var item = secs[i].querySelector('[class*="__media-item"]');
        if (item && !item.querySelector('[data-vip-lookbook]')) return item;
      }
      return null;
    }

    function buildLookbook(looks) {
      var slot = findSlot();
      var host = document.createElement('div');
      host.className = 'vip-root vip-lb';
      lookbookHost = host;
      scope.cleanup(function () { host.remove(); });
      host.setAttribute('data-vip-lookbook', '');
      host.innerHTML =
        '<p class="vip-name"></p>' +
        '<div class="vip-stage" tabindex="-1" role="region" aria-roledescription="carousel" aria-label="Idol looks"><div class="vip-track"></div></div>' +
        '<button type="button" class="vip-arrow vip-arrow--prev" aria-label="Previous look"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M15 4l-8 8 8 8"/></svg></button>' +
        '<button type="button" class="vip-arrow vip-arrow--next" aria-label="Next look"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M9 4l8 8-8 8"/></svg></button>' +
        '<div class="vip-meta"><p class="vip-caption"></p><div class="vip-dots"></div><a class="vip-seeall" href="#"></a></div>';
      if (slot) {
        Array.prototype.forEach.call(slot.children, function (ch) {
          var display = ch.style.display;
          scope.cleanup(function () { ch.style.display = display; });
          ch.style.display = 'none';
          ch.querySelectorAll('video').forEach(function (v) { try { v.pause(); } catch (e) {} v.removeAttribute('autoplay'); });
        });
        slot.appendChild(host);
      } else {
        root.style.display = 'block';
        root.style.padding = '24px 16px';
        root.appendChild(host);
      }

      var stage = host.querySelector('.vip-stage');
      var track = host.querySelector('.vip-track');
      var dotsWrap = host.querySelector('.vip-dots');
      var captionEl = host.querySelector('.vip-caption');
      var prevBtn = host.querySelector('.vip-arrow--prev');
      var nextBtn = host.querySelector('.vip-arrow--next');
      var nameEl = host.querySelector('.vip-name');
      var disc = root.querySelector('[data-vdisc]');
      if (disc) {
        var discParent = disc.parentNode, discNext = disc.nextSibling;
        scope.cleanup(function () { discParent.insertBefore(disc, discNext); });
      }
      if (disc) nameEl.parentNode.insertBefore(disc, nameEl.nextSibling); // name, then the disclaimer, then the photo
      var seeAllEl = host.querySelector('.vip-seeall');
      if (window.VaultClean) window.VaultClean.attach(stage, captionEl); // idle dots, hold for clean view, first-visit hint
      var index = 0;
      var n = looks.length;
      var target = null; // spot whose product ADD TO CART adds (null = the product on this page)

      looks.forEach(function (lk, i) {
        var slide = document.createElement('div');
        slide.__pzLook = lk.lookId; slide.__pzLabel = lk.idol; slide.__pzArtist = lk.artistId; slide.__pzGroups = lk.groupId ? [lk.groupId] : [];
        if (window.VaultPZ && lk.lookId) scope.timeout(function () { window.VaultPZ.watchImpression(slide, lk.lookId); }, 0);
        slide.className = 'vip-slide' + (lk.custom ? ' vil-look--custom' : '');
        if (lk.style) slide.setAttribute('style', lk.style); // the Look's own size (Size for this Look)
        slide.innerHTML = lk.media;
        track.appendChild(slide);
        slide.querySelectorAll('[data-vil-spot]').forEach(function (sp) {
          var isCurrent = sp.getAttribute('data-product-id') === String(cfg.productId) || sp.getAttribute('data-product-handle') === cfg.productHandle;
          if (!isCurrent) return;
          sp.classList.add('is-current');
          var body = sp.querySelector('.vil-spot__body');
          if (body) { var tag = document.createElement('span'); tag.className = 'vip-viewing'; tag.textContent = cfg.viewing || "YOU'RE VIEWING THIS"; body.insertBefore(tag, body.firstChild); }
          var card = sp.querySelector('[data-vil-spot-card]');
          if (card && card.tagName === 'A') scope.on('lookbook.7', card, 'click', function (e) { e.preventDefault(); });
        });
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'vip-dot';
        d.setAttribute('aria-label', 'Look ' + (i + 1) + ' of ' + n);
        scope.on('lookbook.8', d, 'click', function (e) { goTo(i); if (e.isTrusted) pzMoved(track.children[index]); });
        dotsWrap.appendChild(d);
      });
      if (n < 2) { dotsWrap.style.display = 'none'; prevBtn.hidden = true; nextBtn.hidden = true; stage.style.cursor = 'default'; } // one photo: nothing to swipe

      /* "Match the photos": the frame takes the shape of the tallest photo, so no empty bands show. */
      function fitStage() {
        if (cfg.ratio !== 'auto') return;
        var rs = Array.prototype.map.call(track.querySelectorAll('.vil-media'), function (m) {
          return parseFloat(getComputedStyle(m).getPropertyValue('--r'));
        }).filter(function (r) { return r > 0; });
        if (rs.length) stage.style.aspectRatio = String(Math.min.apply(null, rs));
      }
      fitStage();
      scope.on('lookbook.9', window, 'resize', fitStage);

      function setTrack(px, instant) {
        var pos = visualPos(index);
        track.style.transition = instant ? 'none' : '';
        track.style.transform = 'translate3d(calc(' + (-100 * pos) + '% - ' + (16 * pos) + 'px + ' + (px || 0) + 'px), 0, 0)';
      }
      /* Seamless loop: at the ends, the next slide is moved next to the current one so the track
         only ever slides one step (like normal scrolling). Afterwards everything snaps back quietly. */
      var wrapMode = null, wrapTimer = null;
      function setWrap(mode) {
        if (wrapMode === mode) return;
        Array.prototype.slice.call(track.children).forEach(function (l) { l.style.order = ''; });
        wrapMode = mode;
        if (mode === 'next') Array.prototype.slice.call(track.children)[0].style.order = String(n);
        if (mode === 'prev') Array.prototype.slice.call(track.children)[n - 1].style.order = '-1';
      }
      function visualPos(i) {
        if (wrapMode === 'next') return i === 0 ? n - 1 : i - 1;
        if (wrapMode === 'prev') return i === n - 1 ? 0 : i + 1;
        return i;
      }
      function unwrap() { scope.clear(wrapTimer); if (!wrapMode) return; setWrap(null); setTrack(0, true); }
      function edgeDrag(px) {
        if (n < 2) return;
        var m = (index === 0 && px > 0) ? 'prev' : (index === n - 1 && px < 0) ? 'next' : null;
        if (m !== wrapMode) { scope.clear(wrapTimer); setWrap(m); }
      }
      /* Returns the looped index and moves the track (animated, one step even across the ends) */
      function stepTo(raw, instant) {
        var i = n > 1 ? ((raw % n) + n) % n : 0;
        scope.clear(wrapTimer);
        if (instant) { setWrap(null); index = i; setTrack(0, true); return i; }
        if (n > 1 && (raw >= n || raw < 0)) {
          var mode = raw >= n ? 'next' : 'prev';
          if (wrapMode !== mode) { setWrap(mode); setTrack(0, true); void track.offsetWidth; }
        }
        index = i;
        setTrack(0, false);
        if (wrapMode) wrapTimer = scope.timeout(unwrap, 560);
        return i;
      }

      function goTo(i, instant) {
        stepTo(i, instant); // loops around, one step at a time
        if (stage.__vcvWake) stage.__vcvWake(); // new photo → dots back to full, 3s countdown restarts
        dotsWrap.querySelectorAll('.vip-dot').forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
        prevBtn.disabled = n < 2;
        nextBtn.disabled = n < 2;
        captionEl.textContent = looks[index].caption || '';
        var ns = looks[index].nameStyle || {};
        nameEl.textContent = looks[index].idol || '';
        seeAllEl.textContent = looks[index].seeAll || '';
        seeAllEl.href = looks[index].href || '#';
        if (!seeAllEl.__pz) { seeAllEl.__pz = 1; scope.on('lookbook.10', seeAllEl, 'click', function (e) { if (e.isTrusted) { try { window.sessionStorage.setItem('vault_pz_open_next', '1'); } catch (err) {} } }); }
        nameEl.style.setProperty('--vip-n-d', ns.d || '14px');
        nameEl.style.setProperty('--vip-n-m', ns.m || '10px');
        nameEl.style.setProperty('--vip-n-c', ns.c || '#000');
        nameEl.style.setProperty('--vip-n-f', ns.f || "'Archivo Narrow', Arial, sans-serif");
        nameEl.style.setProperty('--vip-n-ls', ns.ls || '.12em');
        closeSpots();
        target = null;
      }

      function closeSpots() { host.querySelectorAll('.vil-spot.is-active').forEach(function (s) { s.classList.remove('is-active'); }); }
      function placeCard(spot) {
        var card = spot.querySelector('[data-vil-spot-card]');
        var box = spot.closest('.vip-slide');
        if (!card || !box) return;
        card.style.left = '0px'; card.style.top = '0px';
        var b = box.getBoundingClientRect(), s = spot.getBoundingClientRect();
        var cw = card.offsetWidth, ch = card.offsetHeight, px = s.left - b.left, py = s.top - b.top;
        var gap = spot.querySelector('[data-vil-spot-btn]').offsetWidth / 2 + 8, m = 20;
        var left = Math.min(Math.max(px - cw / 2, m), Math.max(m, b.width - cw - m)) - px;
        var top;
        if (py + gap + ch <= b.height - m) top = gap;
        else if (py - gap - ch >= m) top = -(gap + ch);
        else top = Math.max(m, Math.min(b.height - ch - m, py - ch / 2)) - py;
        card.style.left = left + 'px'; card.style.top = top + 'px';
      }
      function openSpot(spot) { closeSpots(); spot.classList.add('is-active'); placeCard(spot); target = spot.classList.contains('is-current') ? null : spot; }

      /* Swipe / drag (vertical scroll still works) */
      var drag = null, blockClick = 0;
      scope.on('lookbook.11', stage, 'pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (n < 2 || e.target.closest('[data-vil-spot-card]')) return;
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, t: Date.now(), on: false };
      });
      scope.on('lookbook.12', stage, 'pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!drag.on) {
          if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
          if (Math.abs(dy) >= Math.abs(dx)) { drag = null; return; }
          drag.on = true; try { stage.setPointerCapture(e.pointerId); } catch (err) {}
          closeSpots();
        }
        drag.dx = dx;
        edgeDrag(dx);
        setTrack(dx, true);
      });
      function end(e) {
        if (!drag || e.pointerId !== drag.id) return;
        var s = drag; drag = null;
        if (!s.on) return;
        blockClick = Date.now() + 400;
        var w = stage.clientWidth || 1, v = s.dx / Math.max(1, Date.now() - s.t), dir = 0;
        if (e.type !== 'pointercancel') {
          if (s.dx < -w * 0.18 || (v < -0.4 && s.dx < -24)) dir = 1;
          else if (s.dx > w * 0.18 || (v > 0.4 && s.dx > 24)) dir = -1;
        }
        goTo(index + dir);
        if (dir && e.isTrusted) pzMoved(track.children[index]);
      }
      scope.on('lookbook.13', stage, 'pointerup', end);
      scope.on('lookbook.14', stage, 'pointercancel', end);
      scope.on('lookbook.15', stage, 'click', function (e) {
        if (Date.now() < blockClick) { e.preventDefault(); e.stopPropagation(); return; }
        var btn = e.target.closest('[data-vil-spot-btn]');
        if (btn) {
          e.preventDefault();
          var spot = btn.closest('[data-vil-spot]');
          if (spot.classList.contains('is-active')) { closeSpots(); target = null; }
          else {
            openSpot(spot);
            if (e.isTrusted && window.VaultPZ) {
              var ps = window.VaultPZ.productFromSpot(spot), sl = spot.closest('.vip-slide'), c = pzSlideCtx(sl);
              if (ps) window.VaultPZ.track('hotspot_open', { product: ps, artist: c.artist, groups: c.groups }, 'ho:' + ps.id + ':' + (sl && sl.__pzLook));
            }
          }
          return;
        }
        var cardEl = e.target.closest('[data-vil-spot-card]');
        if (cardEl && cardEl.tagName === 'A' && e.isTrusted && window.VaultPZ && !e.defaultPrevented) {
          var cs = cardEl.closest('[data-vil-spot]'), cp = cs && !cs.classList.contains('is-current') ? window.VaultPZ.productFromSpot(cs) : null, csl = cs && cs.closest('.vip-slide'), cc = pzSlideCtx(csl);
          if (cp) window.VaultPZ.trackProductClick({ product: cp, artist: cc.artist, groups: cc.groups });
        }
        if (!cardEl) { closeSpots(); target = null; }
      }, true);
      scope.on('lookbook.16', stage, 'dragstart', function (e) { e.preventDefault(); });
      scope.on('lookbook.17', prevBtn, 'click', function (e) { goTo(index - 1); if (e.isTrusted) pzMoved(track.children[index]); });
      scope.on('lookbook.18', nextBtn, 'click', function (e) { goTo(index + 1); if (e.isTrusted) pzMoved(track.children[index]); });
      scope.on('lookbook.19', document, 'keydown', function (e) {
        if (n < 2 || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
        var t = e.target;
        if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
        var r = stage.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        e.preventDefault();
        goTo(index + (e.key === 'ArrowRight' ? 1 : -1));
        if (e.isTrusted) pzMoved(track.children[index]);
      });

      /* The product they're viewing: open its card for a few seconds when the lookbook comes into view */
      var autoDone = false;
      function autoOpen() {
        if (autoDone) return;
        autoDone = true;
        var sp = track.children[index] && track.children[index].querySelector('.vil-spot.is-current');
        if (!sp) return;
        openSpot(sp);
        scope.timeout(function () { if (sp.classList.contains('is-active') && target === null) sp.classList.remove('is-active'); }, cfg.autoOpenMs || 5000);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.intersectionRatio >= 0.5) { io.disconnect(); scope.timeout(autoOpen, 400); } }); }, { threshold: [0.5] });
        scope.observe(io).observe(stage);
      }

      goTo(0, true);
      /* the first photo loads early – but only once the page itself has loaded, so it never competes
         with the product photo (the rest stay lazy) */
      var firstImg = track.children[0] && track.children[0].querySelectorAll('img');
      var warmFirst = function () { if (firstImg) firstImg.forEach(function (im) { im.loading = 'eager'; }); };
      if (document.readyState === 'complete') warmFirst(); else scope.on('lookbook.20', window, 'load', warmFirst, { once: true });

      /* Anchor from the WORN BY box: fast start, slow finish (ease-out cubic) */
      host.scrollIntoFocus = function () {
        /* Measured again every frame: images loading above can push the lookbook down mid-scroll. */
        function goal() {
          var r = host.getBoundingClientRect();
          /* Keep the top (idol name) below the sticky header on every phone size */
          var hdrBottom = 0;
          [0.1, 0.5, 0.9].forEach(function (fx) { // whatever is pinned at the top of the screen (the header bar)
            var el = document.elementFromPoint(window.innerWidth * fx, 4);
            while (el && el !== document.body && el !== document.documentElement) {
              var cs = getComputedStyle(el);
              if (cs.position === 'fixed' || cs.position === 'sticky') { var b = el.getBoundingClientRect().bottom; if (b < window.innerHeight / 2) hdrBottom = Math.max(hdrBottom, b); break; }
              el = el.parentElement;
            }
          });
          var room = window.innerHeight - hdrBottom;
          var y = window.pageYOffset + r.top - hdrBottom - Math.max(12, (room - r.height) / 2);
          var max = Math.max(0, html.scrollHeight - window.innerHeight);
          return Math.max(0, Math.min(max, y));
        }
        var start = window.pageYOffset;
        if (reduce || Math.abs(goal() - start) < 2) { window.scrollTo(0, goal()); return; }
        var prev = html.style.scrollBehavior; html.style.scrollBehavior = 'auto';
        var t0 = null, dur = cfg.scrollMs || 3000, stopped = false;
        function stop() { stopped = true; html.style.scrollBehavior = prev; scope.off(window, 'wheel', stop); scope.off(window, 'touchstart', stop); scope.cleanups.delete(stop); }
        scope.cleanup(stop);
        scope.on('lookbook.21', window, 'wheel', stop, { passive: true });
        scope.on('lookbook.22', window, 'touchstart', stop, { passive: true });
        scope.frame(function step(ts) {
          if (stopped) return;
          if (t0 === null) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          window.scrollTo(0, start + (goal() - start) * (1 - Math.pow(1 - p, 3)));
          if (p < 1) scope.frame(step); else stop();
        });
      };
      return host;
    }
  })();

    }
  };
  window.vaultInit.drain('LookbookProduct');
})();
